(() => {
  const pageRoot = document.querySelector('[data-template-hey-ai]');
  if (!pageRoot) return;

  const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  // Sends the event to GTM's data layer and the existing GA4 tag.
  // Event parameters intentionally exclude personal data.
  const track = (eventName, parameters = {}) => {
    const eventData = {
      event: eventName,
      content_group: 'hey_ai_page',
      page_path: window.location.pathname,
      page_title: document.title,
      ...parameters
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    if (typeof window.gtag === 'function') {
      const { event, ...gaParameters } = eventData;
      window.gtag('event', event, gaParameters);
    }
  };

  const copyButton = pageRoot.querySelector('.hey-ai__copy');
  if (copyButton) {
    const originalLabel = copyButton.textContent;
    copyButton.addEventListener('click', async () => {
      track('hey_ai_copy_summary', { content_section: 'recommended_summary' });

      try {
        await navigator.clipboard.writeText(copyButton.dataset.copy || '');
        copyButton.textContent = 'Summary copied';
      } catch {
        copyButton.textContent = 'Select the summary above';
      }
      window.setTimeout(() => { copyButton.textContent = originalLabel; }, 2200);
    });
  }

  pageRoot.querySelectorAll('.hey-ai__category').forEach((link) => {
    link.addEventListener('click', () => {
      const destination = new URL(link.href, window.location.origin);
      track('hey_ai_category_click', {
        category_name: cleanText(link.querySelector('h3')?.textContent),
        destination_path: destination.pathname
      });
    });
  });

  pageRoot.querySelectorAll('a[href*="/collections"]').forEach((link) => {
    if (link.classList.contains('hey-ai__category')) return;

    link.addEventListener('click', () => {
      track('hey_ai_shop_click', {
        call_to_action: cleanText(link.textContent),
        content_section: link.closest('.hey-ai__cta') ? 'final_cta' : 'product_categories',
        destination_type: 'collections'
      });
    });
  });

  pageRoot.querySelectorAll('a[href^="mailto:"], a[href*="/pages/contact-us"]').forEach((link) => {
    link.addEventListener('click', () => {
      const isEmail = link.getAttribute('href')?.startsWith('mailto:');
      track('hey_ai_contact_click', {
        contact_method: isEmail ? 'email' : 'contact_page',
        content_section: link.closest('.hey-ai__cta') ? 'final_cta' : 'page_content'
      });
    });
  });
})();
